'use client';
import React, { useState, useRef } from 'react';
import { pdfjs } from 'react-pdf';
import { Document, Page, Thumbnail } from 'react-pdf';
import isMobile from 'ismobilejs';
import { Stack } from '@/ui/primatives';
import { SuspenseLoader } from '@/components/OxenLoader';
import FullscreenExpando, { FullscreenToggle } from '@/ui/FullscreenExpando';
import useDimensions from '@/hooks/useDimensions';
import Pagination from '@/components/Pagination';

import * as Styled from './styled';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

const PdfFileView: React.FC<{ fileUrl?: string }> = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const elementRef = useRef(null);
  const dimensions = useDimensions(elementRef);
  console.log('dimensions', dimensions);

  const mobileView = isMobile().phone;

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setIsLoaded(true);
    setNumPages(numPages);
  }

  function onPageChange({ selected }: { selected: number }): void {
    const pageNum = selected + 1;
    setPageNumber(pageNum);
  }

  // const { width } = useWindowSize();
  const width = dimensions.width;

  console.log('width', width);

  let showThumbnails = true;
  let pdfWidth = width - 200; // && width < 1400 ? width - 1400 + 1000 : 1000;

  if (width && width < 800) {
    pdfWidth = width - 40;
    showThumbnails = false;
  }

  return (
    <FullscreenExpando>
      <Styled.PdfFileView>
        <div ref={elementRef}>
          <Document
            file={fileUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<SuspenseLoader>Loading PDF</SuspenseLoader>}
          >
            <Styled.PdfDisplay>
              {showThumbnails && (
                <Styled.Thumbnails>
                  <div>
                    {[...Array(numPages).keys()].map((page) => (
                      <Styled.Thumbnail key={`page_${page + 1}`} $selected={pageNumber === page + 1}>
                        <Thumbnail pageNumber={page + 1} width={100} onClick={() => setPageNumber(page + 1)} />
                        <div>
                          {page + 1} of {numPages}
                        </div>
                      </Styled.Thumbnail>
                    ))}
                  </div>
                </Styled.Thumbnails>
              )}
              <Styled.PdfPage>
                <FullscreenToggle iconSize={16} margin={0} style={{ position: 'absolute', top: 5, right: 0 }} />
                <Page pageNumber={pageNumber} width={pdfWidth} />
              </Styled.PdfPage>
            </Styled.PdfDisplay>
          </Document>
        </div>

        {isLoaded && (
          <Stack.Centered>
            <Pagination
              pagination={{
                page_number: pageNumber,
                total_pages: numPages || 1,
                page_size: 1,
                total_entries: numPages || 1,
              }}
              onClick={(i) => onPageChange({ selected: i - 1 })}
            />
          </Stack.Centered>
        )}
      </Styled.PdfFileView>
    </FullscreenExpando>
  );
};

export default PdfFileView;
